export default "__VITE_ASSET__BIKn_uUd__"